import { render } from "./Details.vue?vue&type=template&id=4f4ca970&scoped=true"
import script from "./Details.vue?vue&type=script&lang=js"
export * from "./Details.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-4f4ca970"

export default script